import { render, staticRenderFns } from "./CloStat.vue?vue&type=template&id=f8f20d70&"
import script from "./CloStat.vue?vue&type=script&lang=js&"
export * from "./CloStat.vue?vue&type=script&lang=js&"
import style0 from "./CloStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports